import React from 'react';
import PropTypes from 'prop-types';
import ClearIcon from '../../../shared/Icons/ClearIcon/ClearIcon';
import styles from './Input.module.scss';

export default function HeaderInput(props) {
    const onKeyDown = e => {
        if (e.keyCode === 13) {
            props.onSubmit();
        }
    };

    return (
        <div className={styles.inputGroup}>
            <button
                className={`icon-keyboard ${styles.keyboardButton}`}
                onClick={() => props.showVirtualKeyboard()}
            />
            <input
                className={styles.input}
                placeholder={props.placeholder}
                value={props.value}
                onChange={props.onChange}
                onFocus={props.onFocus}
                maxLength={props.maxLength}
                onKeyDown={onKeyDown}
                onClick={props.onClick}
                disabled={props.inputDisabled}
            />
            <div className={styles.actions}>
                {props.value ? (
                    <ClearIcon onClick={() => props.onChange({ target: { value: '' } })} />
                ) : null}
                <button
                    disabled={props.submitDisabled}
                    className={styles.submitButton}
                    onClick={props.onSubmit}
                >
                    {props.buttonText}
                </button>
            </div>
        </div>
    );
}

HeaderInput.propTypes = {
    width: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
};
